import React, { useCallback, useState } from 'react';
import * as cls from './smarter-energy-insights.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { IMG_PATH } from '../../../constants';

export const SmarterEnergyInsights = () => {
  const [expanded, setExpanded] = useState(false);

  const onArrowHover = useCallback(() => {
    setExpanded(true);
  }, [setExpanded]);

  return (
    <>
      <Typography tag="h2">Smarter Energy Insights for Homes</Typography>

      <Typography style={{ maxWidth: 1050 }}>
        Voltaware is a next-generation <strong>home energy monitor</strong> that
        transforms the way you manage electricity.
        <br />
        Whether you're living in a rented flat or owning a home, Voltaware
        delivers practical, real-time <strong>energy insights</strong> to help
        you <strong>reduce energy bills and improve efficiency</strong>.
        <button
          className={`btn--unstyled ${cls['btn-expand']}`}
          onMouseEnter={onArrowHover}
        >
          <img src={`${IMG_PATH}/arrow-double.svg`} alt="expand" />
        </button>
      </Typography>

      <div
        className={`${cls.expandable} ${expanded ? cls.expanded : ''}`}
        onMouseEnter={onArrowHover}
      >
        <Typography as="span" style={{ fontSize: 30 }}>
          <b>Looking to understand your home electricity usage?</b>
        </Typography>

        <Typography style={{ maxWidth: 1000 }}>
          Voltaware provides real-time home energy monitoring using cutting-edge
          AI.
          <br />
          By combining smart sensor data with intelligent analysis, our platform
          enhances energy efficiency, reduces carbon emissions, and creates
          smarter, more sustainable homes.
        </Typography>
      </div>
    </>
  );
};
